import React from 'react';
import { CheckIcon, LockIcon, DownloadIcon, FileTextIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { consultingPitch, consultingTestimonial, gluteDeliverables, gluteImages, gluteProduct } from '../../data/gluteCopy';
const tracking = {
  name: gluteProduct.name,
  id: gluteProduct.id,
  price: gluteProduct.guidePrice,
  currency: gluteProduct.currency
};
export function GluteOffer() {
  return <section aria-labelledby="glute-oferta" className="w-full bg-coal" data-id="element-101" data-mp="3o5qf6fe4mn8t">
      <div className="mx-auto w-full max-w-5xl px-5 py-16 sm:px-8 sm:py-24 lg:py-32" data-id="element-102" data-mp="3s58xd3ekck7y">
        <div className="mx-auto max-w-2xl text-center" data-id="element-103" data-mp="3e5pou9hub6v4">
          <p className="text-[0.68rem] font-semibold uppercase tracking-[0.22em] text-ember" data-id="element-104" data-mp="3e959drua983x">
            La oferta
          </p>
          <h2 id="glute-oferta" className="mt-5 text-[1.9rem] font-extrabold uppercase leading-[1.02] tracking-tight text-white sm:text-5xl" data-id="element-105" data-mp="22r2n2ffbgapr">
            Recupera el control de tu físico
          </h2>
          <p className="mt-5 text-[1.02rem] leading-relaxed text-white/55 sm:text-lg" data-id="element-106" data-mp="aezntax7nl7c">
            Deja de perder el tiempo en entrenamientos que no te dan resultados. Obtén el código
            completo hoy mismo.
          </p>
        </div>

        <div id="precio-glute" className="mt-10 scroll-mt-6 overflow-hidden rounded-2xl border border-ember/40 bg-coal-card sm:mt-14 sm:scroll-mt-10" data-id="element-107" data-mp="fdu7sg6wzft1">
          <div className="flex flex-wrap items-center justify-between gap-3 border-b border-coal-line px-6 py-4 sm:px-10" data-id="element-108" data-mp="tazaq7bbzyk2">
            <p className="text-[0.72rem] font-bold uppercase tracking-[0.22em] text-white" data-id="element-109" data-mp="132vhs7veaz0f">
              Acceso completo
            </p>
            <p className="inline-flex items-center gap-2 rounded-full bg-ember px-3 py-1 text-[0.68rem] font-bold uppercase tracking-wide text-coal-deep" data-id="element-110" data-mp="y5dbyqcoczwn">
              <span className="h-1.5 w-1.5 rounded-full bg-coal-deep" aria-hidden="true" data-id="element-111" data-mp="182hywsecgzei" />
              Precio de lanzamiento
            </p>
          </div>

          <div className="grid lg:grid-cols-[0.8fr_1.2fr]" data-id="element-112" data-mp="1f799x189coi3">
            <img src={gluteImages.ipad} alt="La guía Glute Lab abierta en un iPad" className="h-56 w-full object-cover object-center sm:h-72 lg:h-full" width={1200} height={900} data-id="element-113" data-mp="1k3rf227i2ouy" />

            <div className="p-6 sm:p-10" data-id="element-114" data-mp="1ytfesz019fgk">
              <div className="flex gap-4" data-id="element-115" data-mp="1ysds1x9nn4j0">
                <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-ember/15" aria-hidden="true" data-id="element-116" data-mp="1yvi5zmcx9emv">
                  <FileTextIcon className="h-4 w-4 text-ember" data-id="element-117" data-mp="27uwuwhdfxh59" />
                </span>
                <div data-id="element-118" data-mp="2csokv5uiyt6t">
                  <h3 className="text-[1.05rem] font-semibold text-white sm:text-lg" data-id="element-119" data-mp="2cqu8ifxbk9ec">
                    Glute Lab: El Código del Crecimiento
                  </h3>
                  <p className="mt-1 text-[0.9rem] leading-relaxed text-white/50" data-id="element-120" data-mp="ifypejoidbxb">
                    Producto digital descargable. Todo el sistema en un solo lugar.
                  </p>
                </div>
              </div>

              <ul className="mt-6 space-y-2.5" data-id="element-121" data-mp="62v100bcdmfi">
                {gluteDeliverables.map(item => <li key={item.title} className="flex gap-3 text-[0.92rem] leading-snug text-white/60 sm:text-base" data-id="element-122" data-mp="13iclb4to7at">
                    <CheckIcon className="mt-1 h-4 w-4 shrink-0 text-ember" strokeWidth={3} aria-hidden="true" data-id="element-123" data-mp="ttqxvbunn7tm" />
                    <span data-id="element-124" data-mp="juhuxthtaiv4">{item.title}</span>
                  </li>)}
              </ul>

              <div className="mt-8 border-t border-coal-line pt-6" data-id="element-125" data-mp="ewzwwy5c1o1w">
                <div className="flex items-end gap-3" data-id="element-126" data-mp="34nmo374d79o6">
                  <span className="text-5xl font-extrabold leading-none tracking-tight text-white sm:text-6xl" data-id="element-127" data-mp="2zngsxgyvz51c">
                    ${gluteProduct.guidePrice.toFixed(2)}
                  </span>
                  <span className="pb-1 text-[0.82rem] leading-snug text-white/45 sm:text-sm" data-id="element-128" data-mp="saflx1uyzjo7">
                    USD · pago único.
                    <br data-id="element-129" data-mp="ievp8d8l0gye" />
                    Acceso de por vida.
                  </span>
                </div>

                <CtaButton tone="ember" label="¡Quiero despertar mis glúteos ahora!" href={gluteProduct.guideCheckoutUrl} tracking={tracking} className="mt-6 w-full" data-id="element-130" data-mp="ne8m7qt634ep" />

                <p className="mt-4 flex flex-wrap items-center justify-center gap-x-5 gap-y-1.5 text-[0.78rem] text-white/40 sm:text-[0.82rem]" data-id="element-131" data-mp="1153mieplod6o">
                  <span className="inline-flex items-center gap-2" data-id="element-132" data-mp="1623wh0pkm032">
                    <LockIcon className="h-4 w-4 text-ember" aria-hidden="true" data-id="element-133" data-mp="3lujido3oes36" />
                    Pago seguro
                  </span>
                  <span className="inline-flex items-center gap-2" data-id="element-134" data-mp="3qv77u5c9b0va">
                    <DownloadIcon className="h-4 w-4 text-ember" aria-hidden="true" data-id="element-135" data-mp="28v7w1l85hyib" />
                    Acceso inmediato
                  </span>
                  <span data-id="element-136" data-mp="23zk7n81ht9dv">Sin mensualidades</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start gap-6 border-t border-coal-line pt-8 sm:mt-14 lg:flex-row lg:items-center lg:justify-between lg:gap-10" data-id="element-137" data-mp="2duu9nvrw5grn">
          <div data-id="element-138" data-mp="1q3f4zwcn6nd8">
            <h3 className="text-[1.02rem] font-semibold text-white sm:text-lg" data-id="element-139" data-mp="1l6yif6l3ch29">
              {consultingPitch.title}
            </h3>
            <p className="mt-1.5 max-w-xl text-[0.92rem] leading-relaxed text-white/50 sm:text-base" data-id="element-140" data-mp="1yz4w8m0rubyj">
              {consultingPitch.text}
            </p>

            <figure className="mt-5 max-w-xl border-l-2 border-ember pl-4" data-id="element-141" data-mp="16hslxqdn14y2">
              <blockquote className="text-[0.9rem] leading-relaxed text-white/70" data-id="element-142" data-mp="16fpl0bay5rek">
                “{consultingTestimonial.quote}”
              </blockquote>
              <figcaption className="mt-2 text-[0.78rem] text-white/40" data-id="element-143" data-mp="31jxdvjk0o4oo">
                <span className="font-semibold text-white/70" data-id="element-144" data-mp="36js6psncr4cd">{consultingTestimonial.name}</span> ·{' '}
                {consultingTestimonial.detail}
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    </section>;
}